export function initMenu() {
    const state = {
        menuIsOpen: false,
        inTransparentSection: false,
        isShrunk: false,
    }

    const button = document.querySelector('[data-open-mobile-navigation]');
    const masthead = document.querySelector(`#masthead`);
    const headerLogo = document.querySelector(`#site-header .custom-logo`);
    const topBanner = document.querySelector('#top-banner');

    // Expose the top banner's live height as a CSS var, so fixed-position
    // headers (e.g. the transparent home page header) can offset content
    // that sits behind them, accounting for the banner's presence/size.
    if (topBanner) {
        const updateTopBannerHeightVar = () => {
            document.documentElement.style.setProperty('--top-banner-height', `${topBanner.offsetHeight}px`);
        };
        updateTopBannerHeightVar();
        new ResizeObserver(updateTopBannerHeightVar).observe(topBanner);
    }

    function renderHeader() {
        masthead.classList.toggle('--is-open', state.menuIsOpen);
        masthead.classList.toggle('--is-transparent', state.inTransparentSection && !state.menuIsOpen);
        emitHeaderChange();
    }

    function emitHeaderChange() {
        window.dispatchEvent(new CustomEvent('header:layout-change'));
    }

    function createOverlay() {
        const el = document.createElement('div');
        el.style.height = '100vh';
        el.style.width = '100vw';
        el.style.position = 'absolute';
        el.style.zIndex = '-1';
        el.setAttribute('data-menu-overlay', '');
        el.addEventListener('click', (e) => {
            state.menuIsOpen = false;
            renderHeader();
            e.target.remove();
        });

        return el;
    }

    button.addEventListener('click', () => {
        state.menuIsOpen = !state.menuIsOpen;
        if (state.menuIsOpen) {
            let overlay = createOverlay();
            masthead.appendChild(overlay);
        } else {
            let overlay = document.querySelector('[data-menu-overlay]');
            if (overlay) overlay.remove();
        }
        renderHeader();
    });

    // Handle styles for transparent menu when overlapping in specified sections
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            state.inTransparentSection = entry.isIntersecting;
            renderHeader();
        });
    }, { threshold: 0, rootMargin: "-90% 0px 0px 0px" });

    const sectionShouldHaveTransparentMenu = document.querySelector(`[data-transparent-menu]`);
    if (sectionShouldHaveTransparentMenu) observer.observe(sectionShouldHaveTransparentMenu);


    // Shrink logo when page is scrolled
    const threshold = 400;
    window.addEventListener('scroll', () => {
        const shouldShrink = window.scrollY > threshold;
        if (shouldShrink !== state.isShrunk) {
            state.isShrunk = shouldShrink;
            masthead.classList.toggle('--is-scrolled')
            emitHeaderChange();
        }
    })

    // Nested links hover
    document.querySelectorAll('#menu-primary-menu > .menu-item-has-children').forEach(link => {
        link.addEventListener('mouseenter', () => link.classList.add('open'));
        link.addEventListener('mouseleave', () => link.classList.remove('open'));
    })
}